<template>
  <div class="text-center">
      
      <v-card>
        <v-card-title class="text-h5 primary white--text">
          Tamaño Documento
        </v-card-title>
        <v-card-text v-if="progress">
            <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
            ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
         <v-row>
             <v-col cols="12">
                <v-btn
                color="primary"
                dark
                x-large
                outlined
                block
                @click="printPDF('fcletter')"
                >
                <v-icon>mdi-file-multiple</v-icon>
                  CARTA
                </v-btn>
             </v-col>
             <v-col cols="12">
                <v-btn
                color="primary"
                dark
                x-large
                outlined
                block
                @click="printPDF('fcmedium')"
                >
                <v-icon>mdi-note-text-outline</v-icon>
                1/2 CARTA
                </v-btn>
             </v-col>
             <v-col cols="12">
                <v-btn
                color="primary"
                dark
                x-large
                outlined
                block
                @click="printPDF('ticket')"
                >
                <v-icon>mdi-receipt</v-icon>
                TICKET
                </v-btn>
             </v-col>
         </v-row>
        </v-card-text>

      </v-card>

  </div>
</template>
<script>
//import Swal from 'sweetalert2';
//import axios from 'axios'
export default {
  props: ["documento"],
  emits: ['opendialog'],
  data:()=>({
    progress:false,
  }),
  computed:{
    getUrlApi(){
        return this.$store.getters.getUrlApi
      },
    getUrlPdf(){
        return this.$store.getters.getUrlPdf
      },  
  },
  methods:{
    async printPDF(size) {
        
        this.progress=true
        let datos = {...this.documento}
        datos.size = size
        
        try {
          
          this.progress=false
          await this.$store.dispatch("generarPdf",datos)
           window.open( `${this.getUrlPdf}/assets/file.pdf`,"blank")
        } catch (error) {
            this.progress=false
          console.log(error)
        }

        this.$emit('opendialog')

      },
      
  }
}
</script>